import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";
import useFfnEventHandlers from "./useFfnEventHandlers";

export const useFfnChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: any[],
) => {
  const { metadataHandler, messageHandler } = useFfnEventHandlers();

  return useOwnChatStream(
    {
      api: `${nuclearn_api_url}/chat/start`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
  );
};
